import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";

import { PageHeader } from "@/components/ui/page-header";
import { usePortalData } from "@/components/portal/PortalDataProvider";
import { ConnectAllowanceCard } from "@/components/portal/knowledgebase-sql/ConnectAllowanceCard";
import { ConnectClaudePanel } from "@/components/portal/knowledgebase-sql/ConnectClaudePanel";

export const Route = createFileRoute("/portal/knowledgebase-sql/connect")({
  component: ConnectClaudePage,
});

function ConnectClaudePage() {
  const { selectedOrganisation } = usePortalData();
  const organisationId = selectedOrganisation?.organisationId;

  return (
    <>
      <Helmet>
        <title>Connect Claude | Knowledgebase Database</title>
      </Helmet>

      <div className="space-y-6">
        <PageHeader
          title="Connect Claude"
          description="Point your own Claude at your data sources over MCP."
        />
        {organisationId && (
          <ConnectAllowanceCard organisationId={organisationId} />
        )}
        <ConnectClaudePanel />
      </div>
    </>
  );
}
